const checkDiscountProductInCart = async function(id,discountcode){
  const response = await fetch("/cart.js");
  const data = await response.json();
  const matched = data.items.filter( item => item.id == id && (item.properties != null && item.properties._isFree == 1));
  return matched.length > 0 ? matched[0].key : false;
};
const removeProductIfDiscountNotExisit = async function(id,discountcode){
  const response = await fetch("/cart.js");
  const data = await response.json();
  const matched = data.items.filter( item => item.id == id && (item.properties != null && item.properties._isFree == 1));
  const discountMatched = data.items.filter( (item) => {
    return item.discounts.filter(discount => discount.title == discountcode).length > 0;
  });
  
  if(discountMatched.length > 0){
    if(matched.length <= 0){
       addRemoveDiscountProduct(id,1);
       document.dispatchEvent(new CustomEvent('cart:build'));
    }
  }else{
     if(matched.length > 0){
        addRemoveDiscountProduct(matched[0].key,0);
       document.dispatchEvent(new CustomEvent('cart:build'));
     }
  }
}

const initCustomDiscountEvent = function() {
  if(document.querySelectorAll(".discount-apply-btn").length > 0){

   const productId = document.querySelector(".discount-apply-btn").dataset.id;
   const code = document.querySelector(".discount-apply-btn").dataset.code;
   removeProductIfDiscountNotExisit(productId,code);
    document.querySelector(".discount-input").addEventListener("keydown", function(event) {
    if (event.key === "Enter") {
      console.log("NAT enter clicked");
        event.stopPropagation();
        event.preventDefault();
        event.stopImmediatePropagation();
          // Do Something, may be an 'Undo' operation
            document.querySelector('.discount-apply-btn').click();
        }
    });
    document.querySelector(".discount-apply-btn").addEventListener("click", async function(e){
       const cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
      
      const button = e.currentTarget;
      const productId = e.currentTarget.dataset.id;
      const code = e.currentTarget.dataset.code;
      const enteredCode = document.querySelector(".discount-input").value;
      button.classList.add('btn--loading');
      let isProductedAdded = false;
      let cartData = false;
      const discountProductOnCart = await checkDiscountProductInCart(productId,code);
       if (enteredCode.toLowerCase() == code.toLowerCase() && (productId != null && productId != '')) {
        if (discountProductOnCart == false) {
            cartData = await addRemoveDiscountProduct(productId, 1);
          isProductedAdded = 1
            //isProductedAdded = await checkDiscountProductInCart(productId,code);
        }
      }
      setTimeout( async function(){
        const discountResponse = await applyCustomDiscount(enteredCode,productId);

        setTimeout( async function(){
          const cartResponse = await fetch("/cart.js");
          const data = await cartResponse.json();
          const discountMatched = data.items.filter( (item) => {
            return item.discounts.filter( discount => discount.title == enteredCode ).length > 0;
          });
          const matched = data.items.filter( item => item.id == productId && (item.properties != null && item.properties._isFree == 1));
        
          if(discountMatched.length <= 0 && matched.length > 0){
             cartData = addRemoveDiscountProduct(matched[0].key, 0);
          }
          
          if(data.cart_level_discount_applications.length <= 0 && discountMatched.length <= 0){
             document.querySelector(".custom-error-div").classList.remove("hidden");
          }
          button.classList.remove('btn--loading');
          fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }
             document.dispatchEvent(new CustomEvent('custom:updated'));
          })
          .catch((e) => {
            console.error(e);
          });
         
        },300);
        
      },500);
      
      
    });
     
  }
};
const updateCustomCartDrawer = async (cart,data) => {
  cart.renderContents(data);
  document.dispatchEvent(new CustomEvent('custom:updated'));
}
const addRemoveDiscountProduct = async function(id,qty){
   const cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
  if(qty == 1){
    let formData = {
     'items': [{
      'id': id,
      'quantity': qty,
       "properties":{
         "_isFree":1
       }
      }],
      sections: cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    };
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
    const data = await response.json();
    return data;
    //document.dispatchEvent(new CustomEvent('cart:build'));
  }else{
    let formData = {
      'id': id,
      'quantity': 0,
      sections: cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    };
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
    const data = await response.json();
     return data;
  }
  return true;
}
const applyCustomDiscount = async function(discountCode ,id){
  const checkoutUrl = `/checkout?discount=${discountCode}`;
  const response = fetch(checkoutUrl);
  return true;
}
const removeCustomDiscount = async function(discountCode){
  const checkoutUrl = `/checkout?discount=${discountCode}`;
  const response = fetch(checkoutUrl);
  return true;
}
const addSecondCrossProduct = async(id,isAdded) =>{
   const cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
   if(isAdded == 1){
    let formData = {
     'items': [{
      'id': id,
      'quantity': 1,
      }],
      sections: cart.getSectionsToRender().map((section) => section.id),
    sections_url: window.location.pathname,
    };
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
    const data = await response.json();
    document.querySelector(".cart-drawer-second-cross-sell input").setAttribute("data-isExist",true);
    document.querySelector(".cart-drawer-second-cross-sell input").setAttribute("data-key",data.items[0].key);
    updateCustomCartDrawer(cart,data);
  }else{
     let formData = {
      'id': id,
      'quantity': 0,
       sections: cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
     };
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
    const data = await response.json();
     document.querySelector(".cart-drawer-second-cross-sell input").setAttribute("data-isExist",false);
      document.querySelector(".cart-drawer-second-cross-sell input").setAttribute("data-key","");
     
    updateCustomCartDrawer(cart,data);
  }
}
const checkSecondCrossOnCart = async() =>{
  if(document.querySelectorAll(".cart-drawer-second-cross-sell").length > 0){
    const inputElement = document.querySelector(".cart-drawer-second-cross-sell input");
    const priceElement = document.querySelector(".cart-drawer-second-cross-sell .second-item_price");
    let vid = inputElement.dataset.pid;
    
    const response = await fetch("/cart.js");
    const data = await response.json();
    
    if(data.item_count > 0){
      const matched = data.items.filter( item => item.id == vid);
      if(matched.length > 0){
        inputElement.setAttribute("data-isExist",true);
        inputElement.setAttribute("data-key",matched[0].key);
        inputElement.checked = true;
        document.querySelector(`.cart-item[data-key="${matched[0].key}"]`).classList.add("hide-product");
      }else{
        inputElement.setAttribute("data-isExist",false);
        inputElement.setAttribute("data-key","");
        inputElement.checked = false;
      }
    }else{
      inputElement.setAttribute("data-isExist",false);
      inputElement.setAttribute("data-key","");
      inputElement.checked = false;
    }
  }
}
const initSecondCrossSellCartEvent = () => {
  if(document.querySelectorAll(".cart-drawer-second-cross-sell").length > 0){
    document.querySelector(".cart-drawer-second-cross-sell input").addEventListener("change",async(evt)=>{
        console.log(evt,"evnt",evt.target.dataset.isexist === 'false');
        let vid = evt.target.dataset.pid;
        if(evt.target.checked == true && evt.target.dataset.isexist === 'false'){
          await addSecondCrossProduct(vid,1);
        }else{
          await addSecondCrossProduct(vid,0);
        }
    });
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
      initSecondCrossSellCartEvent();
  initCustomDiscountEvent();
  document.addEventListener("custom:updated",function(evt){
    console.log("cart event fire");
   
    checkSecondCrossOnCart();
    setTimeout(() => {
       initCustomDiscountEvent();
      initSecondCrossSellCartEvent();
    },500);
    
  });
   subscribe(PUB_SUB_EVENTS.cartUpdate, function(evt){
     console.log("cart event fire on update");
      
     checkSecondCrossOnCart();
    setTimeout(() => {
      initCustomDiscountEvent();
      initSecondCrossSellCartEvent();
    },500);
   });
});
const loadInfinateLoader = () => {
  if(typeof Ajaxinate === 'function'){
     var endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      loadingText:`<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                    </svg>`,
      callback: function(){
        console.log("callback collection load function");
        setTimeout(() => {
          customCollectionEventsInit();
          initlizeCustomButtonsEvents();
        },500);
        
      }
    });
  }
  
}
function extractDiscountPercentage(text) {
    const percentageMatch = text.match(/(\d+)\s?%/);
    if (percentageMatch) {
        return parseFloat(percentageMatch[1]);
    }
    return null;
}
function change_price(){
   let compareElement = document.querySelector('.checked-item .comapre_m');
    let lastPriceElement = document.querySelector('.product__info-wrapper .price-item--sale');
    let savingsPercentElement = document.querySelector('.product__info-wrapper .savings-percent');
    if (compareElement && lastPriceElement && savingsPercentElement) {
        console.log('Raw compare price:', compareElement.innerText);
        if (lastPriceElement.innerText.trim() === "") {
            console.error('Error: last price element is empty');
            return;
        }
        let comparePrice = parseFloat(compareElement.innerText.replace('€', '').replace(',', '.').trim());
        let lastPrice = parseFloat(lastPriceElement.innerText.replace('€', '').replace(',', '.').trim());
        console.log('Parsed compare price:', comparePrice);
        console.log('Parsed last price:', lastPrice);
        if (isNaN(comparePrice) || isNaN(lastPrice)) {
            console.error('Error parsing prices: comparePrice or lastPrice is NaN');
            return;
        }
        let savingsPercent = ((comparePrice - lastPrice) / comparePrice) * 100;
        let roundedSavingsPercent = Math.round(savingsPercent);
        savingsPercentElement.innerText = '-' + roundedSavingsPercent + '%';
    } else {
        console.error('One or more elements not found');
    }
}
jQuery(document).ready(function($){

  $(document).on("click", "details.menu-drawer-container.menu-opening", function(e) {
    // Check if the click was on the main details element and not its children
    if ($(e.target).is(this)) {
        $(this).removeAttr("open");
    }
    $('body').removeClass('body-submenu-open');
});
  
  $(document).on("change",`.shopify_subscriptions_app_block_label input[type="radio"]`,$.proxy(function(){
   // Select the elements
    let compareElement = document.querySelector('.checked-item .comapre_m');
    if(!compareElement){
    const original = $("product-info .savings-percent").data("original");
    const percentage = extractDiscountPercentage(this.ariaLabel);
    if(percentage != null ){
     $("product-info .savings-percent").text(`-${percentage}%`);
    }else{
       $("product-info .savings-percent").text(`-${original}%`);
    }
      }else{
   change_price();
      }
  }));

  $(document).on("click",".custom-popup-opener",function(){
     $(`.custom-modal__centered.active`).removeClass("active");
    $(`body`).addClass("custom-model-open");
      const dataId = $(this).data("id");
      $(`.custom-modal__centered[data-id="${dataId}"]`).addClass("active");
  });
  $(document).on("click",".custom-popup-opener-a",function(){
     $(`.custom-modal__centered.active`).removeClass("active");
    $(`body`).addClass("custom-model-open");
      const dataId = $(this).data("id");
      $(`.custom-modal__centered[data-id="${dataId}"]`).addClass("active");
  });
  
   $(document).on("click",".custom-modal__close",function(){
     $(`.custom-modal__centered.active`).removeClass("active");
     $(`body`).removeClass("custom-model-open");

  });
  
  $(document).on("click",".custom-filter-box ",function(){
      $(".custom-filter-box").removeClass("active");
      $(this).addClass("active");
      const dataId = $(this).data("id");
     const isClickedFirst = $(this).hasClass("first-class");
     
      $(".filter-items").each( function(){
        if(isClickedFirst){
           $(".filter-items").removeClass("hide").slideDown(); 
        }else{
          if($(this).attr("id") != dataId){
            $that = $(this);
            $(this).slideUp(function(){
              $that.addClass("hide");
            });
          }else{
            $(this).removeClass("hide");
            $(this).slideDown();
          }
        }
        
      });
      
    }); 
  $(document).on("change",".custom-swatch-element .custom-swatch-radio",function(){
    const mainElement = $(this).parents(".custom-swatches-new-wrapper");
    mainElement.find(".custom-swatch-element").removeClass("checked-item");
    $(this).parent(".custom-swatch-element").addClass("checked-item"); 
  });

  $(document).on("change",".custom-review-tab-selector",function(){
    setTimeout(function(){
      window.dispatchEvent(new Event("resize"));
    },500);
  });
  if($('.custom-offer-announcement .utility-bar__grid').length > 0){
    $('.custom-offer-announcement .utility-bar__grid').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 6000,
      pauseOnHover: false,
      cssEase: 'linear',
      arrows: false,
      dots: false,
      responsive: [
          {
              breakpoint: 1200,
              settings: {
                  speed: 6000
              }
          },
          {
              breakpoint: 992,
              settings: {
                  speed: 4000
              }
          },
          {
              breakpoint: 768,
              settings: {
                  speed: 2000
              }
          },
          {
              breakpoint: 480,
              settings: {
                  speed: 1000
              }
          }
      ]
  });
  }
  
  if($('.trust-slider').length > 0){
     $('.trust-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  adaptiveHeight: true,    
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
  }

   

     $(document).on("click",".collapsible-accordion summary",function(e){
       e.preventDefault();
        $('.collapsible-accordion .accprdomg_main').not($(this).parent()).removeClass('active');
        $('.collapsible-accordion .accordion-main').not( $(this).next()).slideUp();
       $(this).parent().toggleClass('active');
        $(this).next().slideToggle();
      });
   $('etrusted-rc-carousel-review-tile').hide();
   $('etrusted-rc-carousel-review-tile [rating="5"]').parents('etrusted-rc-carousel-review-tile').show();
   if(document.querySelectorAll("#ProductGridContainer").length > 0){
    loadInfinateLoader();
  }
  // $( "ul.mega-menu__list.page-width > li" ).hover(function() {
  //    // $(this).siblings().find('ul').css('display','none');
  //    $(this).find('ul').css('display','grid');
  // });
  var lastScrollTop = 0;
  $(window).scroll(function () {
    var st = $(this).scrollTop();
    if( $(window).scrollTop() > $('header').offset().top && !($('body').hasClass('sticky-header'))){
        $('body').addClass('sticky-header');
        $('.newsleter-bar').addClass('active');
    }
    //this is when user scrolls down: hide the class after 500
    if (st > lastScrollTop) {
        if ( $(window).scrollTop() < 500){
        $('body').removeClass('another-sticky-header');
        $('.newsleter-bar').removeClass('active');  
        }
    }
    //this is when user scrools up: before 500 add class
    if (st < lastScrollTop) {
        //here 500 is used to make the effect last longer you can make it 50 as you wish to do in OP
        if ( $(window).scrollTop() > 500){
            $('body').addClass('another-sticky-header');
          $('.newsleter-bar').addClass('active');  
        }
    }
    if ($(window).scrollTop() == 0){
        $('body').removeClass('sticky-header');
        $('body').removeClass('another-sticky-header');
        $('.newsleter-bar').removeClass('active');
    }
    
    lastScrollTop = st;
  });

  // $(document).on("click", ".accordion.content-container details summary", function () {
  //     $(this).parent('details').parent().siblings().children().removeAttr('open');
  // });
});

function recommendationAddProductToCart(evt) {
  const cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
  const submitButton = evt.currentTarget;
  submitButton.setAttribute("aria-disabled", true);
  submitButton.classList.add("loading");
  submitButton
    .querySelector(".loading__spinner")
    .classList.remove("hidden");
  const mainId = submitButton.dataset.vid;
  let items = [
    {
      id: mainId,
      quantity: 1,
    },
  ];
  let formData = {
    items: items,
    sections: cart.getSectionsToRender().map((section) => section.id),
    sections_url: window.location.pathname,
  };
  fetch(`${routes.cart_add_url}.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: "product-form",
          productVariantId: mainId,
          errors: response.description,
          message: response.message,
        });

        const soldOutMessage = submitButton.querySelector(".sold-out-message");
        if (!soldOutMessage) return;
        submitButton.setAttribute("aria-disabled", true);
        submitButton.querySelector("span").classList.add("hidden");
        soldOutMessage.classList.remove("hidden");
      } else if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "product-form",
        productVariantId: mainId,
      });
      cart.renderContents(response);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      submitButton.classList.remove("loading");
      if (cart && cart.classList.contains("is-empty"))
        cart.classList.remove("is-empty");
      submitButton.removeAttribute("aria-disabled");
      submitButton
        .querySelector(".loading__spinner")
        .classList.add("hidden");
    });
}

var reinitCustomAddtoCartButtons = function () {
  document.querySelectorAll(".recommandaion-product-add").forEach((el) => {
    el.addEventListener("click", recommendationAddProductToCart);
  });
};
var loadProductRecommendationsIntoSectionCart = function () {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(
    ".product-recommendations-cart"
  );
  if (productRecommendationsSection === null) {
    return;
  }

  // Read vars from attributes
  var productId = productRecommendationsSection.dataset.productId;
  var limit = productRecommendationsSection.dataset.limit;
  var adv_ratio = productRecommendationsSection.dataset.adv_ratio;
  var prod_thumb_img_ratio =
    productRecommendationsSection.dataset.prod_thumb_img_ratio;

  // Build request URL
  var requestUrl =
    productRecommendationsSection.dataset.url +
    "?section_id=product-recommendation-cart&limit=" +
    limit +
    "&product_id=" +
    productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function () {
    if (request.status >= 200 && request.status < 300) {
      
      productRecommendationsSection.innerHTML = new DOMParser()
        .parseFromString(request.response, "text/html")
        .querySelector(".product-recommendations-cart").innerHTML;
      reinitCustomAddtoCartButtons();
      // set correct image shape
      
    }
  };
  request.send();
};

if(window.location.href == "https://www.naturaforce.com/pages/programme-fidelite"){
  setTimeout(() => {
    console.log($('div#smile-ui-lite-launcher-frame-container iframe'));
  }, 3000);
}
theme.Shopify = {
  formatMoney: function formatMoney(t, r) {
    function e(t, r) {
      return void 0 === t ? r : t;
    }
    function a(t, r, a, o) {
      if (
        ((r = e(r, 2)), (a = e(a, ",")), (o = e(o, ".")), isNaN(t) || null == t)
      )
        return 0;
      t = (t / 100).toFixed(r);
      var n = t.split(".");
      return (
        n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) +
        (n[1] ? o + n[1] : "")
      );
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var o = "",
      n = /\{\{\s*(\w+)\s*\}\}/,
      i = r || this.money_format;
    switch (i.match(n)[1]) {
      case "amount":
        o = a(t, 2);
        break;
      case "amount_no_decimals":
        o = a(t, 0);
        break;
      case "amount_with_comma_separator":
        o = a(t, 2, ".", ",");
        break;
      case "amount_with_space_separator":
        o = a(t, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        o = a(t, 2, " ", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        o = a(t, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        o = a(t, 0, " ", "");
        break;
      case "amount_with_apostrophe_separator":
        o = a(t, 2, "'", ".");
        break;
      case "amount_with_decimal_separator":
        o = a(t, 2, ".", ".");
    }
    return i.replace(n, o);
  },
};
if (!customElements.get('simple-progress-bar')) {
  customElements.define(
    'simple-progress-bar',
    class SimpleProgressBar extends HTMLElement {
      constructor() {
        super();

        this.t1 = this.dataset.t1 ? (+this.dataset.t1 * Shopify.currency.rate) : 0;
        this.t2 = this.dataset.t2 ? (+this.dataset.t2 * Shopify.currency.rate) : 0;
        this.t3 = this.dataset.t3 ? (+this.dataset.t3 * Shopify.currency.rate) : 0;
        this.t4 = this.dataset.t4 ? (+this.dataset.t4 * Shopify.currency.rate) : 0;
        this.t5 = this.dataset.t5 ? (+this.dataset.t5 * Shopify.currency.rate) : 0;
        
        
        this.giftProducts = this.dataset.t1products;
        this.gift2Products = this.dataset.t2products;
        this.gift3Products = this.dataset.t3products;
        this.gift4Products = this.dataset.t4products;
        this.gift5Products = this.dataset.t5products;

        this.t1MatchedProducts = [];
        this.t2MatchedProducts = [];
        this.t3MatchedProducts = [];
        this.t4MatchedProducts = [];
        this.t5MatchedProducts = [];
        
        this.totalMatchedCart = [];
        this.productIds = [];

         this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
        this.updateThresholdPriceBox();
        this.init();
      }
      
      calculatePercentage(amount) {
        let percentage = 0;
        let next_goal;
        const thresholds = [this.t1, this.t2, this.t3, this.t4, this.t5].filter(t => t > 0);
        const thresholds_areas = thresholds.length + 1;
        let next_threshold = 1;

        for (let i = 0; i < thresholds.length; i++) {
          if (amount < thresholds[i]) {
            next_goal = thresholds[i];
            next_threshold = i + 1;
            break;
          } else {
            next_goal = thresholds[i];
            next_threshold = i + 1;
          }
        }

        if (amount >= thresholds[thresholds.length - 1]) {
          percentage = 100;
        } else {
          let threshold_distance = (100 / thresholds_areas);
          let completed_thresholds_distance = ((next_threshold - 1) * threshold_distance);
          percentage = ((amount * 1.0) / next_goal * threshold_distance) + completed_thresholds_distance;
          percentage = percentage - 4;
        }

        return percentage;
      }
      updateThresholdPriceBox() {
        if (this.t1 > 0) this.querySelector(`.position-bar-box-container[data-number="1"] .price-box`).textContent = theme.Shopify.formatMoney((this.t1 * 100), "{{amount_no_decimals}} €");
        if (this.t2 > 0) this.querySelector(`.position-bar-box-container[data-number="2"] .price-box`).textContent = theme.Shopify.formatMoney((this.t2 * 100), "{{amount_no_decimals}} €");
        if (this.t3 > 0) this.querySelector(`.position-bar-box-container[data-number="3"] .price-box`).textContent = theme.Shopify.formatMoney((this.t3 * 100), "{{amount_no_decimals}} €");
        if (this.t4 > 0) this.querySelector(`.position-bar-box-container[data-number="4"] .price-box`).textContent = theme.Shopify.formatMoney((this.t4 * 100), "{{amount_no_decimals}} €");
        if (this.t5 > 0) this.querySelector(`.position-bar-box-container[data-number="5"] .price-box`).textContent = theme.Shopify.formatMoney((this.t5 * 100), "{{amount_no_decimals}} €");
      }
      async init() {
          const thresholds = [this.t1, this.t2, this.t3, this.t4, this.t5].filter(t => t > 0);
          let giftItems = [
            this.giftProducts,
            this.gift2Products,
            this.gift3Products,
            this.gift4Products,
            this.gift5Products,
          ];
          const tMatchedProducts = Array(5).fill([]);
          this.totalMatchedCart = [];
          this.productIds = [];
          const tGifItems = giftItems.map(gift => (gift != "" ? gift.split("___") : []));
          let progressBar1 = this.querySelector("#cprogressbar1");
         
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          this.totalMatchedCart = cart.items.filter(item => item.properties._isGift == 1);
          let giftPrice = 0;
          const totalGiftProduct = this.findItemInCart(cart,[]);
          if (totalGiftProduct.length > 0) {
            this.totalMatchedCart = totalGiftProduct;
            giftPrice = totalGiftProduct.reduce((total, item) => total + item.final_line_price, 0);
          }
          const cartTotalIncent = (cart.total_price - giftPrice);
          const cartTotal = cartTotalIncent/100;
          let percentage = this.calculatePercentage(cartTotal);
          this.needToRemoved=[];

          let nextThresholdIndex = thresholds.findIndex(threshold => (cartTotal < threshold));
          nextThresholdIndex = nextThresholdIndex === -1 ? thresholds.length : nextThresholdIndex;

          const sippingAmount = nextThresholdIndex < thresholds.length ? (thresholds[nextThresholdIndex] * 100 - cartTotalIncent) : 0;

          if (nextThresholdIndex > 0) {
            const previousThresholdIndex = nextThresholdIndex - 1;
            this.productIds = this.prepareProductIdForCart(tGifItems[previousThresholdIndex], this.findItemInCart(cart, tGifItems[previousThresholdIndex]));
            if(tGifItems[previousThresholdIndex].length > 0){
              this.needToRemoved = this.findDeletedItems(cart, tGifItems[previousThresholdIndex]);
            }
            
          } else {
            this.needToRemoved = this.findDeletedItems(cart, []);
          }
          this.updateMessage(nextThresholdIndex, sippingAmount);
          if (this.needToRemoved.length > 0) {
            let updates = this.needToRemoved.reduce((acc, { key, quantity }) => {
              acc[key] = 0;
              return acc;
            }, {});
            this.removeGifts(updates, this.productIds.length <= 0);
          }
          if (this.productIds.length > 0) {
            this.addGifts(this.productIds, 1);
          }
          
          if (Shopify.currency.active != 'EUR') {
            progressBar1.style.width = `${percentage}%`;
          }
          
         
      }
      prepareProductIdForCart(giftItems,matchedItems){
        let productIds = [];
         if(giftItems.length > 0 && matchedItems.length <= 0){
          for(let i in giftItems){
              productIds.push(giftItems[i]);
          }
        }else if(giftItems.length > 0 && matchedItems.length > 0 &&  giftItems.length != matchedItems.length){
          for(let i in giftItems){
              const giftProductId = +giftItems[i];
              const isAdded = matchedItems.filter(item1 => item1.id == giftProductId && item1.properties._isGift == 1);
              if(isAdded.length <= 0){
                productIds.push(giftItems[i]);
              }
          }
        }
        return productIds;
      }
      findItemInCart(cart,products){
         if(products.length > 0){
          return cart.items.filter(item => products.includes(`${item.id}`) && item.properties._isGift == 1 );
         }else{
           return cart.items.filter(item => item.properties._isGift == 1 );
         }
      }
      findDeletedItems(cart,excludeProducts){
        if(excludeProducts.length > 0){
          return this.totalMatchedCart.filter(item => excludeProducts.includes(`${item.id}`) == false && item.properties._isGift == 1);
        }
        return this.totalMatchedCart.filter(item => item.properties._isGift == 1);
      }
      updateMessage(t, amount) {
        console.log(t,amount,"ddddddd");
        const messages = this.querySelectorAll(".progressbar-threshold-message");
        const progressBars = this.querySelectorAll(".position-bar-box-container");
         const thresholds = [this.t1, this.t2, this.t3, this.t4, this.t5].filter(t => t > 0);
      
        // Hide all messages and deactivate all progress bars initially
        messages.forEach(el => el.classList.add("hide"));
        progressBars.forEach(el => el.classList.remove("activated"));
      
        if (typeof t === 'undefined' || t >= thresholds.length) {
          // Show success message if no threshold is provided or all thresholds are reached
          messages.forEach(el => {
            if (el.classList.contains("success-t")) {
              el.classList.remove("hide");
            }
          });
          progressBars.forEach(el => el.classList.add("activated"));
        } else {
          if(t <= 0){
            messages.forEach(el => {
                if (el.classList.contains(`t1`)) {
                  el.classList.remove("hide");
                  el.querySelector(".custom-amount").textContent = theme.Shopify.formatMoney(amount, theme.money_format);
                }
              });
          }else{
            // Show specific threshold message
              messages.forEach(el => {
                if (el.classList.contains(`t${t+1}`)) {
                  el.classList.remove("hide");
                  el.querySelector(".custom-amount").textContent = theme.Shopify.formatMoney(amount, theme.money_format);
                }
              });
              progressBars.forEach(el => {
                if (Number(el.dataset.number) <= t) {
                  el.classList.add("activated");
                }
              });
          }
          
        }
      }
      removeGifts(updates,isUpdate){
          const body = JSON.stringify({
            updates,
            sections: this.cart.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
          });
          fetch(`/cart/update.js`,{
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: body
            })
            .then((response) => response.json())
            .then((response) => {
               if(isUpdate == true){
                if(window.location.pathname == '/cart'){
                   window.location.reload(true);
                  return;
                }
                  const cartDrawerWrapper = document.querySelector('cart-drawer');
                  if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', response.item_count === 0);
                 this.cart.renderContents(response);
              }
          });
        
      }
      addGifts(productIds,isUpdate){
        let items = [];
          console.log(productIds,"dddd");
          items = productIds.map((id) => {
            return {
              "id":id,
              "quantity":1,
              "properties":{
                "_isGift":1
              }
           };
          });
          let formData = {
           'items':items,
            sections: this.cart.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
          };
          fetch(`/cart/add.js`,{
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then((response) => response.json())
          .then((response) => {
           
              if(isUpdate == 1){
                if(window.location.pathname == '/cart'){
                  window.location.reload(true);
                  return;
                }
                 publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: this.productIds[0],
                });
                
                this.cart.renderContents(response);
              }
          });  
       }
     }
  );
}
function checkAttributeAndModifyStyles(targetElement) {
    const headerSearch = targetElement;
    if (headerSearch) {
        if (!headerSearch.hasAttribute('open')) {
            const collectionSwatchSection = document.querySelector('.collection-swatch-section__wrapper');
            const home_page_section = document.querySelector('#shopify-section-template--16202326048815__image_banner_BWCRgf');
            if (collectionSwatchSection) {
                collectionSwatchSection.style.marginTop = '66px';
            }
            else if (home_page_section) {
                home_page_section.style.marginTop = '65px';
            }
        }
    }
}
 window.addEventListener('scroll', function() {
            if (document.body.classList.contains('index') || document.body.classList.contains('collection')) {
                var targetElement = document.querySelector('.header__search details');
              if (window.innerWidth < 1100) {
              //  checkAttributeAndModifyStyles(targetElement);
              }
                if (window.scrollY > 10) {
                    targetElement.setAttribute('open', 'true');
                } 
            }
        });

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
     this.endDate = new Date(this.getAttribute('end-date'));
  }

  updateCountdown() {
    const now = new Date();
    const timeRemaining = new Date(this.endDate) - new Date(now);

    if (timeRemaining <= 0) {
      // Countdown has ended, hide the element
      this.style.display = "none";
      document.querySelector(".countdown-wrapper").style.display="none";
    } else {
      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      let hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      this.querySelector(".days-counter").innerHTML = String(days).padStart(2, '0');
      this.querySelector(".hours-counter").innerHTML = String(hours).padStart(2, '0');
      this.querySelector(".minutes-counter").innerHTML = String(minutes).padStart(2, '0');
      this.querySelector(".seconds-counter").innerHTML = String(seconds).padStart(2, '0');
    }
  }
  addHTML(){
     this.innerHTML = `
        <div class="timer-item days-item"><span class="small-size">J</span><span class="days-counter">${String(0).padStart(2, '0')}</span></div>
        <div class="timer-item colon-item"><span>:</span></div>
        <div class="timer-item hours-item"><span class="small-size">H</span><span class="hours-counter">${String(0).padStart(2, '0')}</span></div>
        <div class="timer-item colon-item"><span>:</span></div>
        <div class="timer-item minutes-item"><span class="small-size">M</span><span class="minutes-counter">${String(0).padStart(2, '0')}</span></div>
        <div class="timer-item colon-item"><span>:</span></div>
        <div class="timer-item seconds-items"><span class="small-size">S</span><span class="seconds-counter">${String(0).padStart(2, '0')}</span></div>`;
    
  }
  connectedCallback() {
    this.addHTML();
    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

customElements.define("countdown-timer", CountdownTimer);
document.addEventListener("DOMContentLoaded", function() {
   document.querySelectorAll(".custom-upsell-add").forEach((el) => {
    el.addEventListener("click", recommendationAddProductToCart);
  });
    const links = document.querySelectorAll('.product__title a[href^="#"],.newsleter-bar');
    links.forEach(link => {
        link.addEventListener("click", function(event) {
            event.preventDefault();

            const targetID = this.getAttribute("href").substring(1);
            const targetElement = document.getElementById(targetID);

            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop,
                    behavior: "smooth"
                });
            }
        });
    });
});
document.querySelectorAll('.custom-header-mega-menu-left-part li a').forEach(link => {
    link.addEventListener('mouseenter', function() {
       document.querySelectorAll('.custom-header-mega-menu-right-part-child').forEach(child => {
            child.classList.remove('active');
        });
        const targetClass = this.getAttribute('data-target');
        document.querySelector('.' + targetClass).classList.add('active');
    });
});
const child = document.querySelector('.custom-header-mega-menu-child-wrapper');
    if (child) {
      console.log('method called');
        child.addEventListener('mouseenter', function() {
            const parent = this.closest('.mega-menu');
            if (parent) {
                parent.classList.add('menu_hover');
                parent.setAttribute('open',true);
            }
        });
    }

document.addEventListener("DOMContentLoaded", (event) => {

 subscribe(PUB_SUB_EVENTS.variantChange, function(evt){
   if(evt.data.variant){
     if(document.querySelectorAll(".custom-variant-images-div").length > 0){
       if(document.querySelectorAll(`.custom-variant-images-div .customvimage[data-vid="${evt.data.variant.id}"]`).length > 0){
         const ImageUrl = document.querySelector(`.custom-variant-images-div .customvimage[data-vid="${evt.data.variant.id}"]`).dataset.src;
         document.querySelectorAll(".custom-swatch-element .image_coll img").forEach((el) => {
           el.src=ImageUrl;
         })
       }
     }
   }
 });
   if(document.querySelectorAll(".custom-variant-images-div").length > 0){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
     const variantId = urlParams.get("variant");
     if(variantId != null && variantId != ""){
        if(document.querySelectorAll(`.custom-variant-images-div .customvimage[data-vid="${variantId}"]`).length > 0){
         const ImageUrl = document.querySelector(`.custom-variant-images-div .customvimage[data-vid="${variantId}"]`).dataset.src;
         document.querySelectorAll(".custom-swatch-element .image_coll img").forEach((el) => {
           el.src=ImageUrl;
         })
       }
     }
   }

  const subscriptionWidgetIneterval = setInterval(() => {
    if(document.querySelectorAll(".appstle_sub_widget").length > 0){
      /*const customHtml = `<div class="sub-custom-title-wrapper"><div class="sub-widget-main-title">Offre Black Friday</div><div class="sub-widget-main-sub-title">Des prix bas toute l'année</div></div>`;
      if(document.querySelectorAll(".sub-custom-title-wrapper").length <= 0){
        document.querySelector(".product-form__buttons .appstle_sub_widget").insertAdjacentHTML('beforebegin', customHtml);
      }*/
      if(document.querySelectorAll(".custom-subscription-gift-block").length > 0){
        const giftblockClone = document.querySelector(".custom-subscription-gift-block").cloneNode(true);
        giftblockClone.classList.remove("hidden");
        document.querySelector(".custom-subscription-gift-block").remove();
         document.querySelector(".product-form__buttons .appstle_sub_widget").after(giftblockClone);
      }
      
      clearInterval(subscriptionWidgetIneterval);
    }
    if(document.querySelectorAll(".shopify_subscriptions_app_block_label_children").length > 0){
      document.querySelectorAll(".shopify_subscriptions_app_block_label_children").forEach((el)=>{
          el.querySelectorAll("li").forEach((li,index) => {
            const label = li.querySelector("label");
            let defaultText = "Livraison mensuelle, 15% de réduction";
            if(index == 1){
              defaultText = "Livraison tous les 3 mois, 10% de réduction";
            }
              // Check if the label element exists
              if (label) {
                // Get the child nodes of the label element
                const childNodes = label.childNodes;
            
                // Loop through the child nodes to find the text node
                  if (childNodes[2].nodeType === Node.TEXT_NODE) {
                    // Replace the text content
                    childNodes[2].nodeValue = defaultText;
                    //break; // Exit the loop once the text node is found and updated
                  }
                
              }
            
          });
      });
      clearInterval(subscriptionWidgetIneterval);
    }
  },500);

  
});

 if($(".collection-swatch-section__content").length > 0 && $(".collection-swatch-section__content .story-card.active").length > 0){
    const acItem = document.querySelector(".collection-swatch-section__content .active");
    let tabwidth = acItem.offsetWidth;
    acItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }


if (typeof Swiper == "undefined") {
    addScript();
  }
 // product page ugc video slider
function waitForSwiper(trigger) {
  var interval = setInterval(function () {
    if (typeof Swiper != "undefined") {
      clearInterval(interval);
      trigger();
    }
  }, 50);
  setTimeout(function () {
    clearInterval(interval);
  }, 15000);
}
function addScript() {
  var swiperScript = document.createElement("script");
  swiperScript.src =
    "https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.0.7/js/swiper.min.js";
  document.getElementsByTagName("head")[0].appendChild(swiperScript);
}


waitForSwiper(function () {
    if(document.querySelectorAll(".custom-banner-slider").length > 0){
      const customBannerSlider = new Swiper(".custom-banner-slider .swiper-container", {
          // Optional parameters
          direction: "horizontal",
          spaceBetween: 0,
          slidesPerView: 1,
          roundLengths: true,
          loop: true,
          arrow: false,
         autoplay: {
          delay: 5000,
        },
        speed: 800
        });
    }
  });
  
  document.addEventListener('StartAsyncLoading',function(event){
    setTimeout(function() {
    egswiperTiktok = new Swiper(".eg-video-section .swiper-container", {
      // Optional parameters
      direction: "horizontal",
      spaceBetween: 20,
      slidesPerView: 4,
      roundLengths: true,
      loop: true,
      arrow: true,
      breakpoints: {
        1199: {
          slidesPerView: 4,
        },
        991: {
          slidesPerView: 3.3,
        },
        800: {
          slidesPerView: 2.6,
          arrow: false,
        },
        500: {
          slidesPerView: 1.2,
        },
        320: {
          slidesPerView: 1.2,
        },
      },
      pagination: {
        el: ".slider__pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
      
      }, 500);
  });
        // Function to generate dynamic IDs from header text and add event listeners
         function addDynamicIdsAndLinks() {
            const headers = document.querySelectorAll('.page .rte.scroll-trigger h2,.page .rte.scroll-trigger h3,.page .rte.scroll-trigger h4');
            const navList = document.getElementById('dynamic-nav');
            const dynamic_nav_wrapper = document.querySelector('.dynamic_nav_wrapper');
            let currentUl = navList;
            let lastHeaderLevel = 2;
            if(headers.length == 0 && dynamic_nav_wrapper){
              dynamic_nav_wrapper.remove();
            }
            headers.forEach(header => {
                // Generate a dynamic ID based on the text content
                const textContent = header.textContent.trim();
                const dynamicId = textContent.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
                header.id = dynamicId;

                // Create a list item with a link
                const listItem = document.createElement('li');
                const link = document.createElement('a');
                link.href = '#' + dynamicId;
                link.textContent = textContent;
                listItem.appendChild(link);

                // Adjust list nesting based on header level
                const headerLevel = parseInt(header.tagName.charAt(1));
                if (headerLevel > lastHeaderLevel) {
                    const newUl = document.createElement('ul');
                    currentUl.lastElementChild.appendChild(newUl);
                    currentUl = newUl;
                } else if (headerLevel < lastHeaderLevel) {
                    currentUl = navList;
                    for (let i = 2; i < headerLevel; i++) {
                        currentUl = currentUl.lastElementChild.lastElementChild;
                    }
                }

                currentUl.appendChild(listItem);
                lastHeaderLevel = headerLevel;
            });
        }
         function toggleNav() {
            const dynamicNav = document.getElementById('dynamic-nav');
            dynamicNav.style.display = (dynamicNav.style.display === 'none' || dynamicNav.style.display === '') ? 'block' : 'none';
        }
        // Call the function to add dynamic IDs and links on page load
        document.addEventListener('DOMContentLoaded', addDynamicIdsAndLinks);
document.addEventListener('click', function(event) {
            if (event.target.tagName === 'A' && event.target.hash !== '') {
                event.preventDefault();
                const targetId = event.target.hash.substring(1);
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    window.scrollTo({
                        top: targetElement.offsetTop,
                        behavior: 'smooth'
                    });
                }
            }
        });





    var waitForElement = function (selector, trigger, delayInterval, delayTimeout) {
      var interval = setInterval(function () {
        if (
          document &&
          document.querySelector(selector) &&
          document.querySelectorAll(selector).length > 0
        ) {
          clearInterval(interval);
          trigger();
        }
      }, delayInterval);
      setTimeout(function () {
        clearInterval(interval);
      }, delayTimeout);
    }

    function getParameters(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    var init = function () {
      console.log("init");
      var promo = getParameters('camp'); console.log(promo);
      if(promo.indexOf("packs") > -1) {
        console.log("do sthg");
        var reco = document.querySelector(".feature-product-bg");
        if (typeof (reco) != 'undefined' && reco != null) {
          var ttl = document.querySelector(".collection_title");
          ttl.insertAdjacentElement("afterend", reco);
          document.querySelector('[data-section-type="collection-swatches"]').style.display = "none";
          document.querySelector('.search-modal').style.display = "none";
          sessionStorage.setItem("packs-discount", "ON");
          document.querySelector(".custom-announcementbar-slider").style.display = "block";
        }
      }
    }

    waitForElement('.collection_title', init, 500, 15000);

    localStorage.setItem("lastname", "Smith");
    if(sessionStorage.getItem("packs-discount") == "ON") {
      document.querySelector(".custom-announcementbar-slider").style.display = "block";
    }
const changeRewardsText = function(){
   document.querySelector(".appstle-loyalty-billing-cycle span sup").textContent="ère";
   document.querySelector(".appstleLoyaltyTable td").innerHTML = document.querySelector(".appstleLoyaltyTable td").innerHTML.replace("Après","Après la")
}
waitForElement('.appstle_loyalty_title', changeRewardsText, 500, 15000);

document.addEventListener('StartAsyncLoading',function(event){
  setTimeout(function() {
    new Swiper('.collection-menu-slider', {
        loop: true, // Enable loop
        spaceBetween: 5,
        slidesPerView: 'auto', // Show 3 slides at a time
        autoplay: {
            delay: 3000, // Slide every 3 seconds
            // disableOnInteraction: false, // Keep autoplay working even after user interacts
        },
        speed: 600, // Set transition speed to 600ms for smooth scroll
        pagination: {
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            1920: {
                spaceBetween: 5,
                slidesPerView: 'auto', // Show 3 slides on larger screens
            },
            1028: {
                spaceBetween: 5,
                slidesPerView: 'auto', // Show 3 slides on medium screens
            },
            767: {
                spaceBetween: 5,
                slidesPerView: 'auto', // Show 1 slide on smaller screens
            },
            0: {
                spaceBetween: 5,
                slidesPerView: 'auto', // Show 1 slide on mobile
            }
        }
    });
    }, 500);
});

function customCollectionEventsInit(){
  const allVariantSelectors = document.querySelectorAll(".custom-variant-select-box");
    if(allVariantSelectors.length > 0){
      allVariantSelectors.forEach((el) => {
        el.addEventListener("change",(evt) => {
          const mainGridElement = el.closest(".grid__item");
          console.log(mainGridElement,"mainGridElementmainGridElement");
          const selectedId = el.value;
          mainGridElement.querySelectorAll(".custom-pack-grid-variant-price").forEach((priceEl) => {
            if(priceEl.dataset.vid == selectedId){
              priceEl.classList.remove("hidden");
            }else{
              priceEl.classList.add("hidden");
            }
          });
          mainGridElement.querySelectorAll(".custom-pack-info-base-on-variant").forEach((priceEl) => {
            if(priceEl.dataset.vid == selectedId){
              priceEl.classList.remove("hidden");
            }else{
              priceEl.classList.add("hidden");
            }
          });
        });
      });
    }
    // Get all slider wrappers
      const sliderWrappers = document.querySelectorAll('.custom-product-grid-slider-wrapper');

      // Initialize Swiper for each wrapper
      sliderWrappers.forEach((wrapper) => {
        const swiperContainer = wrapper.querySelector('.swiper');
        if(!swiperContainer.swiper){
          const swiper = new Swiper(swiperContainer, {
            navigation: {
              nextEl: wrapper.querySelector('.swiper-button-next'),
              prevEl: wrapper.querySelector('.swiper-button-prev'),
            },
            pagination: {
              el: wrapper.querySelector('.swiper-pagination'),
            }
          });
        }
        
      });

        document.querySelectorAll(".custom-variant-selection-item input").forEach((input) => {
          input.addEventListener("change",(evt) => {
            const mainElement = input.closest(".custom-hover-wrapper");
            mainElement.querySelectorAll(".price-wrapper").forEach((el) => {
              if(el.dataset.vid == evt.target.value){
                el.classList.remove("hidden");
              }else{
                el.classList.add("hidden");
              }
            });
            mainElement.querySelectorAll(".custom-subscription-item .price-block").forEach((el) => {
              if(el.dataset.vid == evt.target.value){
                el.classList.remove("hidden");
              }else{
                el.classList.add("hidden");
              }
            });
          });
        });
}
  document.addEventListener("DOMContentLoaded", function() {
    customCollectionEventsInit();
    const chatBoxButton = document.querySelector(".chat-box-button");
    
    chatBoxButton.addEventListener("click", function() {
      const targetButton = document.querySelector('app-button button');
      
      if (targetButton) {
        console.log("Target button found, triggering click");
        targetButton.click(); // Trigger the click on the target button
      } else {
        console.log("Target button not found");
      }
    });
  });

$('.close-icon').on("click", function() {
  //$("#Details-menu-drawer-container").removeClass("menu-opening");
  $("body").removeClass("overflow-hidden-tablet");
  $("body").removeClass("body-submenu-open");
  $("#Details-menu-drawer-container").removeAttr("open");
});

$(window).scroll(function() {    
    $("details.menu_hover").attr("open", "true");
});
$(".chat-box-button").on('click', function(){
    //$('button#Avada-FAQ_WidgetTrigger').click();
    open_chat_custom();
});
$("ul.menu-drawer__menu.has-submenu.list-menu li .menu-drawer__menu-item").on('click', function() {
  // Calculate the scroll position to make the menu item 42px from the top of the container
  var scrollToPosition = $(".menu-drawer__navigation-container").offset().top - $('div#menu-drawer').offset().top + 42;
  console.log("scrollToPosition:", scrollToPosition);
  if(scrollToPosition <= 0){
    // Animate the scroll
    $('div#menu-drawer').animate({
      scrollTop: scrollToPosition
    }, 300);
  }

  // Delay adding the class until after the animation finishes
  setTimeout(() => {
    $('div#menu-drawer').addClass('sub-menu-open');
  }, 300); // Adjusted timeout to match animation duration
});

$(".desktop-menu-drawer-container .childlink-block .childlink-blocks").on('click', function(){
    $('.menu-drawer').removeClass('sub-menu-open');
    //console.log("ffff");
});


document.addEventListener('StartAsyncLoading',function(event){  
  var $desktopMenu = $('.menu-drawer__navigation.desktop .menu-drawer__menu.has-submenu ').clone(true);
  $('#link-complements-alimentaires .menu-drawer__inner-submenu').append($desktopMenu);

  $(".menu-drawer__navigation.mobile ul.menu-drawer__menu.has-submenu.list-menu li details details").on('click', function() {
    document.body.scrollTop = 0;
    $(this).addClass('menu-opening mobile-menu-open');
    $(this).attr('open');
  });  
    
  $(".menu-drawer__navigation.mobile ul.menu-drawer__menu.has-submenu.list-menu li details details .menu-drawer__close-button").on('click', function(){
    $(".mobile-menu-open").removeAttr('open');
    $(".mobile-menu-open").removeAttr('class');
  }); 

  setTimeout(() => {
      if(window.innerWidth > 991){
        document.querySelectorAll(".menu-drawer__navigation li.active details").forEach((el) => {  
          const buttonClose = el.querySelector(".menu-drawer__close-button");
           buttonClose.setAttribute("disabled","disabled");
          el.setAttribute('open',true);
          el.classList.add('menu-opening');
        });
      }
  },200);
  
});


$(document).ready(function() {
  if($(".timer-icon-width-text h6").length > 0){
    // Example usage
    const inputText = $(".timer-icon-width-text h6").html();
    const updatedText = replaceTextBasedOnTime(inputText);
    $(".timer-icon-width-text h6").html(updatedText);
  }
  var blogslider = new Swiper('.pdp-blog-swiper', {
    // loop: true,
    slidesPerView: 2,
    spaceBetween: 30,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
   breakpoints: {
         0: {
          slidesPerView: 1,
          spaceBetween: 30
        },
        575: {
          slidesPerView: 2,
          spaceBetween: 30
        },
      }
  });
});
setInterval(function time(){
  var d = new Date();
  var hours = 24 - d.getHours();
  var min = 60 - d.getMinutes();
  if((min + '').length == 1){
    min = '0' + min;
  }
  var sec = 60 - d.getSeconds();
  if((sec + '').length == 1){
        sec = '0' + sec;
  }
  
  jQuery('#the-final-countdown').html(hours+'h '+min+'min '+sec+'sec');
 
}, 1000);

function replaceTextBasedOnTime(text) {
    const now = new Date();
    const franceTime = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', hour: 'numeric' }).format(now);
    
    if (parseInt(franceTime, 10) < 13) {
        return text.replace(/demain matin/g, "aujourd'hui");
    }
    return text;
}
document.addEventListener("DOMContentLoaded", function () {
  lightGallery(document.getElementById("swiper-container"), {
      speed: 500,
      plugins: [lgZoom],
      selector: ".swiper-slide a"
  });
  lightGallery(document.getElementById("swiper-containers"), {
      speed: 500,
      plugins: [lgZoom],
      selector: ".swiper-slide a"
  });
});

function initlizeCustomButtonsEvents(){
  const allHoveropeners = document.querySelectorAll(".custom-hover-opner");
    if(allHoveropeners.length > 0){
      allHoveropeners.forEach((button) => {
        button.addEventListener("click",(evt) => {
          const mainElement = button.closest(".grid__item");
          
          if(mainElement.querySelector(".custom-hover-wrapper")){
            if(mainElement.querySelector(".hover-hide")){
              mainElement.querySelector(".hover-hide").style.visibility = "hidden";
            }
            mainElement.querySelector(".custom-hover-wrapper").style.display = "flex";
          }
        });
      });
    }
    

    const allHoverClosers = document.querySelectorAll(".custom-hover-closer-button");
    if(allHoverClosers.length > 0){
      allHoverClosers.forEach((button) => {
        button.addEventListener("click",(evt) => {
          const mainElement = button.closest(".grid__item");
          
          if(mainElement.querySelector(".custom-hover-wrapper")){
            if(mainElement.querySelector(".hover-hide")){
              mainElement.querySelector(".hover-hide").style.visibility = "visible";
            }
            mainElement.querySelector(".custom-hover-wrapper").style.display = "none";
          }
        });
      });
    }
    
  const modals = document.querySelectorAll('.custom-modal__centered.bundle-price-main-modal-main-element');

  // Add click event to each modal
  modals.forEach(function(modal) {
    modal.addEventListener('click', function(event) {
      // Check if the click was directly on the modal overlay (not on its children)
      if (event.target === modal) {
        // Remove the 'active' class to close the modal
        modal.classList.remove('active');
      }
    });
  });
}
// Initialize the observer when the page is ready
document.addEventListener('DOMContentLoaded', () => {
    initlizeCustomButtonsEvents();

  subscribe(PUB_SUB_EVENTS.variantChange, function(evt){
     if(window.Samita && window.Samita.Wholesale && window.Samita.Wholesale.product){
        window.Samita.Wholesale.product.variants.map((variant) => {
          console.log(variant,"variant");
          if(variant.finalPrice){
            const mainElement = document.querySelector(`.custom-swatch-element[data-variantid="${variant.id}"] label`);
            if(mainElement){
              const boitDevision = +mainElement.dataset.bdivision;
              const priceDevision = (variant.finalPrice / boitDevision).toFixed(2);
              const priceHtml = `${priceDevision}€/boite`;
             mainElement.querySelector('.price-block span').textContent = priceHtml;
              
            }
          }
        });
      }
   });
  
  // Wait a short time to ensure all elements are loaded
  if(document.body.classList.contains("product")){
    const samitaAppInterval = setInterval(() => {
     console.log(window.Samita.Wholesale.summaries,"window.Samita.Wholesale.summaries");
      if(window.Samita && window.Samita.Wholesale && window.Samita.Wholesale.product && window.Samita.Wholesale.summaries && window.Samita.Wholesale.summaries.length > 0 && window.Samita.Wholesale.summaries[0].summary && window.Samita.Wholesale.summaries[0].summary.id){
       const appliedId = window.Samita.Wholesale.summaries[0].summary.id;
       
        /*window.Samita.Wholesale.product.variants.map((variant) => {
          console.log(variant,"variant");
          if(variant.finalPrice){
            const mainElement = document.querySelector(`.custom-swatch-element[data-variantid="${variant.id}"] label`);
            if(mainElement){
              const boitDevision = +mainElement.dataset.bdivision;
              const priceDevision = (variant.finalPrice / boitDevision).toFixed(2);
              const priceHtml = `${priceDevision}€/boite`;
             mainElement.querySelector('.price-block span').textContent = priceHtml;
              
            }
          }
        });*/
        window.Samita.Wholesale.product.id
        const wholeSaleItem = window.Samita.Wholesale.wholesalePricing[window.Samita.Wholesale.summaries[0].summary.id].configs.discount_for_variants.filter(item => item.id == window.Samita.Wholesale.product.id);
        if(wholeSaleItem.length > 0){
          wholeSaleItem[0].variants.map((variant) => {
           
            const pVariant = window.Samita.Wholesale.product.variants.filter(v => v.id == variant.id);
             
            if(variant.discount_groups){
              const mainElement = document.querySelector(`.custom-swatch-element[data-variantid="${variant.id}"] label`);
              if(mainElement && pVariant.length > 0){
                const discountedPrice = Number(variant.discount_groups[0].value) * 100;
                const finalPrice = (pVariant[0].price - discountedPrice) / 100;
                const boitDevision = +mainElement.dataset.bdivision;
                const priceDevision = (finalPrice / boitDevision).toFixed(2);
                const priceHtml = `${priceDevision}€/boite`;
               mainElement.querySelector('.price-block span').textContent = priceHtml;
                
              }
            }
          });
        }                              
        if(document.querySelector(`body[samitaws-element="handle"]`)){
          clearInterval(samitaAppInterval);
        }
        
      }
    },3000);
  }
});

if(document.body.classList.contains('bfcm-vip-success')) {
  console.log("Success page");
  document.querySelector('.klaviyo-form button[type="button"]').addEventListener('click', function () {
    console.log("Shared on WhatsApp");
    klaviyo.track('Clicked Whatsapp Share');
  });
}
window.addEventListener('load', function() {
    const sectionElement = document.querySelector(".custom-nv-collection-swatches");
    if(sectionElement){
        const acItem = sectionElement.querySelector(".story-card.eg-active");
        if(acItem){
          let tabwidth = acItem.offsetWidth;
          sectionElement.querySelector(".eg-tabs-nav__position").style.cssText = '--width:' + tabwidth + 'px;--prevWidth:' + (acItem.offsetLeft) + 'px;';
          acItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
        
    }
});
class CountDownStorage extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
  }

  connectedCallback() {
    const rawTime = this.getAttribute('data-time'); // "H-MM-SS"
    const useStorage = this.getAttribute('data-storage') === "true";
    const compId = this.getAttribute('id');

    if (!rawTime || !compId) return;

    const initialSeconds = this.parseTimeToSeconds(rawTime);

    let remaining = initialSeconds;

    // Recuperar del sessionStorage si corresponde
    if (useStorage) {
      const saved = sessionStorage.getItem(`countdown-${compId}`);
      if (saved !== null) {
        remaining = parseInt(saved, 10);
      }
    }

    this.render(remaining);

    this.interval = setInterval(() => {
      if (remaining <= 0) {
        this.render(0);
        clearInterval(this.interval);
        return;
      }

      remaining--;

      if (useStorage) {
        sessionStorage.setItem(`countdown-${compId}`, remaining);
      }

      this.render(remaining);
    }, 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  parseTimeToSeconds(str) {
    const [h, m, s] = str.split('-').map(n => parseInt(n, 10) || 0);
    return (h * 3600) + (m * 60) + s;
  }

  formatTime(seconds) {
    const h = Math.floor(seconds / 3600);                 // sin cero delante
    const m = Math.floor((seconds % 3600) / 60)
                .toString().padStart(2, '0');             // siempre 2 dígitos
    const s = (seconds % 60).toString().padStart(2, '0'); // siempre 2 dígitos
    return `${h}:${m}:${s}`;
  }

  render(seconds) {
    this.textContent = this.formatTime(seconds);
  }
}
customElements.define('count-down-storage', CountDownStorage);

class CountDownStorage2 extends HTMLElement {
  constructor() {
    super();
    this.endTime = new Date(this.getAttribute("data-time")).getTime();
    this.targetElementId = this.dataset.target;
    //this.shadow = this.attachShadow({ mode: "open" });
  }

  updateCountdown() {
    const now = new Date().getTime();
    const timeRemaining = this.endTime - now;

    if (timeRemaining <= 0) {
      // Countdown has ended, hide the element
      this.style.display = "none";
      //this.closest('.gradient').style.display="none";
      const targetElement = document.querySelector(`.${this.targetElementId}`);
      if(targetElement){
        targetElement.style.display="none";
      }
    } else {
      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      /*this.innerHTML = `
        <div class="timer-item days-item"><span>${String(days).padStart(2, '0')}</span><span class="small-size">days</span></div>
        <div class="timer-item hours-item"><span>${String(hours).padStart(2, '0')}</span><span class="small-size">hours</span></div>
        <div class="timer-item minutes-item"><span>${String(minutes).padStart(2, '0')}</span><span class="small-size">minutes</span></div>
        <div class="timer-item seconds-items"><span>${String(seconds).padStart(2, '0')}</span><span class="small-size">seconds</span></div>
      `;*/
      this.innerHTML = `${String(days).padStart(2, '0')}:${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
   
    }
  }
  addHTML(){
    this.innerHTML = `00:00:00:00`;
  }
  connectedCallback() {
    this.addHTML();
    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

customElements.define("count-down-storage-2", CountDownStorage2);

function closeFilterForm(){
  //document.querySelector(".mobile-facets__disclosure").removeAttribute('open');
  document.querySelector(".mobile-facets__disclosure .mobile-facets__open-wrapper").dispatchEvent(new Event('click'))
}